import { useRef } from "react";

export function useRefFunc<T>(fn: T) {
  const ref = useRef<T>(fn);
  ref.current = fn;
  return ref;
}
